// extracted by mini-css-extract-plugin
export default {"leader":"copyTrading_leader__DfhvJ","follower":"copyTrading_follower__2nk5a"};